import { isObject } from 'helpers/Object';
import { UiService } from 'modules/ui';

import { KNOWN_ERROS } from '../../../constants';

const handleError = (error) => {
  const { data } = error;
  const { INVALID_ACTIONS } = KNOWN_ERROS;
  const invalidAction = isObject(data) && data?.errorCode === INVALID_ACTIONS;

  if (invalidAction) {
    UiService.setAlertError('blocked_user_invalid_action');
    return;
  }

  UiService.handleError(error);
};

export { handleError };
